import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Chart from "react-apexcharts";
import { FaUsers, FaCrown, FaBolt, FaCalendarCheck, FaBan, FaUserClock } from "react-icons/fa";
import Notification from "../components/ToastNotification/Notification";
import socket from "./socket";
function AdminDashboard() {
  const navigate = useNavigate();

  //     useEffect(()=>{

  //     socket.on("newService",(data)=>{
  //         showToast(data.message,'success');

  //     });

  //     socket.on("newPlan",(data)=>{
  //         showToast(data.message,'success');

  //     });

  //     return ()=>{
  //         socket.off("newService");
  //         socket.off("newPlan");
  //     };

  // },[]);

  const [activeTab, setActiveTab] = useState("all");
  const [getService, setGetService] = useState([]);
  const [plans, setPlan] = useState([]);
  const [users, setUSers] = useState([]);
  const [getStaff, setGetStaff] = useState([]);
  const [fetchQuick, setFetchQuick] = useState([]);
  const [data, setData] = useState([]);
  const [todayPlans, setTodayPlans] = useState([]);
  const [todayUsers, setTodayUsers] = useState(0);
  const [monthUsers, setMonthUsers] = useState(0);
  const [totalPlans, setTotalPlans] = useState(0);
  const [todayPlanCount, setTodayPlanCount] = useState(0);
  const [monthPlanCount, setMonthPlanCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  useEffect(() => {
    socket.on("newService", data => {
      setNotifications(prev => [{
        type: "service",
        message: data.message,
        time: new Date().toLocaleTimeString()
      }, ...prev]);
    });
    socket.on("newPlan", data => {
      setNotifications(prev => [{
        type: "plan",
        message: data.message,
        time: new Date().toLocaleTimeString()
      }, ...prev]);
    });
    return () => {
      socket.off("newService");
      socket.off("newPlan");
    };
  }, []);
  const [quickStats, setQuickStats] = useState({
    total: 0,
    today: 0,
    month: 0
  });
  const [scheduleStats, setScheduleStats] = useState({
    total: 0,
    today: 0,
    month: 0
  });
  const [cancelledStats, setCancelledStats] = useState({
    total: 0,
    today: 0,
    month: 0
  });
  const [pendingStaffStats, setPendingStaffStats] = useState({
    total: 0,
    today: 0,
    month: 0
  });
  const filteredData = activeTab === "all" ? fetchQuick : fetchQuick.filter(item => item.pay_mode?.toLowerCase() === activeTab.toLowerCase());
  const transactions = [{
    name: "Riya",
    amount: 1200,
    status: "Success"
  }, {
    name: "Aman",
    amount: 800,
    status: "Pending"
  }, {
    name: "John",
    amount: 1500,
    status: "Success"
  }, {
    name: "Sohan",
    amount: 600,
    status: "Pending"
  }];
  const fetchService = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-service");
      const sortedData = res.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setGetService(sortedData);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchPlan = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-subscription-plan");
      setPlan(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchUser = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-users");
      const filteredUsers = res.data.filter(user => user.id !== 1);
      setUSers(filteredUsers);
      const today = new Date();
      const startOfToday = new Date(today.setHours(0, 0, 0, 0));
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const todayUsers = filteredUsers.filter(u => {
        const created = new Date(u.created_on);
        return created >= startOfToday;
      });
      const monthUsers = filteredUsers.filter(u => {
        const created = new Date(u.created_on);
        return created >= startOfMonth;
      });
      setTodayUsers(todayUsers.length);
      setMonthUsers(monthUsers.length);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSetaff = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-staff");
      const sortedData = res.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setGetStaff(sortedData);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchQuickService = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-quick-service");
      const data = res.data;
      setFetchQuick(data);
      const now = new Date();
      const todayStr = now.toISOString().split("T")[0];

      // =========================
      // QUICK SERVICES
      // =========================
      const quickServices = data.filter(item => item.service_type === "Quick");
      const quickToday = quickServices.filter(item => item.created_on?.split(" ")[0] === todayStr);
      const quickMonth = quickServices.filter(item => {
        const date = new Date(item.created_on);
        return date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
      });
      setQuickStats({
        total: quickServices.length,
        today: quickToday.length,
        month: quickMonth.length
      });

      // =========================
      // SCHEDULE SERVICES
      // =========================
      const scheduleServices = data.filter(item => item.service_type === "Scheduled");
      const scheduleToday = scheduleServices.filter(item => item.created_on?.split(" ")[0] === todayStr);
      const scheduleMonth = scheduleServices.filter(item => {
        const date = new Date(item.created_on);
        return date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
      });
      setScheduleStats({
        total: scheduleServices.length,
        today: scheduleToday.length,
        month: scheduleMonth.length
      });

      // =========================
      // CANCELLED SERVICES
      // =========================

      const cancelledServices = data.filter(item => item.service_status === "Cancelled");
      const cancelledToday = cancelledServices.filter(item => item.created_on?.split(" ")[0] === todayStr);
      const cancelledMonth = cancelledServices.filter(item => {
        const date = new Date(item.created_on);
        return date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
      });
      setCancelledStats({
        total: cancelledServices.length,
        today: cancelledToday.length,
        month: cancelledMonth.length
      });

      // =========================
      // STAFF NOT ALLOCATED
      // =========================

      const pendingStaffServices = data.filter(item => item.staff_id === null || item.staff_id === "" || item.staff_id === undefined);
      const pendingStaffToday = pendingStaffServices.filter(item => item.created_on?.split(" ")[0] === todayStr);
      const pendingStaffMonth = pendingStaffServices.filter(item => {
        const date = new Date(item.created_on);
        return date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
      });
      setPendingStaffStats({
        total: pendingStaffServices.length,
        today: pendingStaffToday.length,
        month: pendingStaffMonth.length
      });
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSubHistory = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-subscription-history");
      const data = res.data;
      setData(data);

      // Total Purchase Plans
      setTotalPlans(data.length);
      const now = new Date();
      const todayStr = now.toISOString().split("T")[0];

      // Today's Plans
      const todayPlans = data.filter(item => {
        return item.rec_date?.split(" ")[0] === todayStr;
      });
      setTodayPlans(todayPlans);
      setTodayPlanCount(todayPlans.length);

      // Current Month Plans
      const currentMonthPlans = data.filter(item => {
        const date = new Date(item.rec_date);
        return date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
      });
      setMonthPlanCount(currentMonthPlans.length);
    } catch (error) {
      console.log(error);
    }
  };
  const allocatedCount = data.filter(item => item.is_allot === 1).length;
  const notAllocatedCount = data.filter(item => item.is_allot === 0).length;
  useEffect(() => {
    fetchService();
    fetchPlan();
    fetchUser();
    fetchSetaff();
    fetchQuickService();
    fetchSubHistory();
  }, []);
  const isSuccess = status => status?.toLowerCase().includes("success");
  const chartOptions = {
    chart: {
      type: "donut"
    },
    labels: ["Allocated", "Not Allocated"],
    colors: ["#22c55e", "#f59e0b"],
    legend: {
      labels: {
        colors: "#fff"
      }
    }
  };
  const chartSeries = [allocatedCount, notAllocatedCount];
  return <div className="container-fluid mt-3 mb-3">
      <h2 className="text-white text-center mb-4">Admin Dashboard</h2>
      
        {/* <ToastNotification
         show={toast.show}
         message={toast.message}
         bg={toast.bg}
         onClose={() => setToast({ ...toast, show: false })}
         /> */}

      <Notification notifications={notifications} />

   
<div className="row g-4 mb-4">
  

  {/* USERS */}
  <div className="col-12 col-md-4">
    <div className="p-4 h-100" style={{
          background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
          borderRadius: "18px",
          color: "#fff",
          cursor: "pointer",
          boxShadow: "0 10px 25px rgba(37,99,235,.25)"
        }} onClick={() => navigate("/admin/user-list")}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="m-0 fw-bold">App Users</h5>
        <FaUsers size={28} />
      </div>

      <p className="mb-2">Total : {users.length}</p>
      <p className="mb-2">Today's : {todayUsers}</p>
      <p className="mb-0">Current Month : {monthUsers}</p>
    </div>
  </div>

  {/* SUBSCRIPTION */}
  <div className="col-12 col-md-4">
    <div className="p-4 h-100" style={{
          background: "linear-gradient(135deg,#16a34a,#15803d)",
          borderRadius: "18px",
          color: "#fff",
          cursor: "pointer",
          boxShadow: "0 10px 25px rgba(22,163,74,.25)"
        }} onClick={() => navigate("/admin/subscription-history")}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="m-0 fw-bold">Subscription Plan</h5>
        <FaCrown size={28} />
      </div>

      <p className="mb-2">Total : {totalPlans}</p>
      <p className="mb-2">Today's : {todayPlanCount}</p>
      <p className="mb-0">Current Month : {monthPlanCount}</p>
    </div>
  </div>

  {/* QUICK */}
  <div className="col-12 col-md-4">
    <div className="p-4 h-100" style={{
          background: "linear-gradient(135deg,#06b6d4,#0891b2)",
          borderRadius: "18px",
          color: "#fff",
          cursor: "pointer",
          boxShadow: "0 10px 25px rgba(6,182,212,.25)"
        }} onClick={() => navigate("/admin/quick-history")}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="m-0 fw-bold">Quick Service</h5>
        <FaBolt size={28} />
      </div>

      <p className="mb-2">Total : {quickStats.total}</p>
      <p className="mb-2">Today's : {quickStats.today}</p>
      <p className="mb-0">Current Month : {quickStats.month}</p>
    </div>
  </div>

  {/* SCHEDULED */}
  <div className="col-12 col-md-4">
    <div className="p-4 h-100" style={{
          background: "linear-gradient(135deg,#8b5cf6,#7c3aed)",
          borderRadius: "18px",
          color: "#fff",
          cursor: "pointer",
          boxShadow: "0 10px 25px rgba(139,92,246,.25)"
        }} onClick={() => navigate("/admin/quick-history")}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="m-0 fw-bold">Scheduled Booking</h5>
        <FaCalendarCheck size={28} />
      </div>

      <p className="mb-2">Total : {scheduleStats.total}</p>
      <p className="mb-2">Today's : {scheduleStats.today}</p>
      <p className="mb-0">Current Month : {scheduleStats.month}</p>
    </div>
  </div>

  {/* CANCELLED */}
  <div className="col-12 col-md-4">
    <div className="p-4 h-100" style={{
          background: "linear-gradient(135deg,#ef4444,#dc2626)",
          borderRadius: "18px",
          color: "#fff",
          cursor: "pointer",
          boxShadow: "0 10px 25px rgba(239,68,68,.25)"
        }} onClick={() => navigate("/admin/quick-history")}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="m-0 fw-bold">Cancelled Booking</h5>
        <FaBan size={28} />
      </div>

      <p className="mb-2">Total : {cancelledStats.total}</p>
      <p className="mb-2">Today's : {cancelledStats.today}</p>
      <p className="mb-0">Current Month : {cancelledStats.month}</p>
    </div>
  </div>

  {/* PENDING STAFF */}
  <div className="col-12 col-md-4">
    <div className="p-4 h-100" style={{
          background: "linear-gradient(135deg,#f59e0b,#d97706)",
          borderRadius: "18px",
          color: "#fff",
          cursor: "pointer",
          boxShadow: "0 10px 25px rgba(245,158,11,.25)"
        }} onClick={() => navigate("/admin/quick-history")}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="m-0 fw-bold">New Service Allocation</h5>
        <FaUserClock size={28} />
      </div>

      <p className="mb-2">Total : {pendingStaffStats.total}</p>
      <p className="mb-2">Today's : {pendingStaffStats.today}</p>
      <p className="mb-0">Current Month : {pendingStaffStats.month}</p>
    </div>
  </div>

</div>

      {/* ================= MAIN SECTION ================= */}
      <div className="row">

     
        <div className="col-md-6">

      <div className="card bg-dark text-white p-3 shadow">

  
  <div className="d-flex justify-content-between mb-3">
    <h5>Quick Service Collection</h5>

    <div>
      <button className={`btn btn-sm me-2 ${activeTab === "all" ? "btn-primary" : "btn-outline-light"}`} onClick={() => setActiveTab("all")}>
        All
      </button>

      <button className={`btn btn-sm me-2 ${activeTab === "Online" ? "btn-info" : "btn-outline-light"}`} onClick={() => setActiveTab("Online")}>
        Online
      </button>

      <button className={`btn btn-sm ${activeTab === "Cash" ? "btn-warning" : "btn-outline-light"}`} onClick={() => setActiveTab("Cash")}>
        Cash
      </button>
    </div>
  </div>

  {/* LIST (SCROLLABLE) */}
  {/* <div style={{ maxHeight: "350px", overflowY: "auto" }}> */}
  <div className="custom-scrollbar" style={{
            maxHeight: "350px",
            overflowY: "auto",
            overflowX: "hidden",
            paddingRight: "4px"
          }}>

    {filteredData.length === 0 && <p className="text-center text-muted">No transactions found</p>}

    {filteredData.map((item, i) => <div key={item.id} className="d-flex justify-content-between align-items-center border-bottom py-2">

        {/* LEFT */}
        <div>
          <strong>{item.users_name}</strong>
          <div className="small text-muted">
            {item.staff_name} • {item.pay_mode}
          </div>
        </div>

        {/* RIGHT */}
        <div className="text-end">

          <div className="fw-bold">
            ₹ {item.amount}
          </div>

          <div className={isSuccess(item.pay_status) ? "text-success small" : "text-warning small"}>
            {item.pay_status}
          </div>

        </div>

      </div>)}

  </div>
</div>
        </div>

    <div className="col-md-6">

  <div className="card bg-dark text-white p-2 shadow" style={{
          cursor: "pointer"
        }} onClick={() => navigate("/admin/subscription-history")}>

    <h6 className="mb-3">Subscription Plan Allocation</h6>

    <Chart options={chartOptions} series={chartSeries} type="donut" height={200} />

    {/* Summary */}
    <div className="d-flex justify-content-between mt-3">

      <div>
        <span className="text-success">● Allocated</span>
        <div className="fw-bold">{allocatedCount}</div>
      </div>

      <div>
        <span className="text-warning">● Not Allocated</span>
        <div className="fw-bold">{notAllocatedCount}</div>
      </div>

    </div>

  </div>

</div>

      </div>
 

    </div>;
}
export default AdminDashboard;
